<template>
  <li class="nav-item" v-if="showComponent"
      :title="qaAble ? showIfHasPermission?.toString() : null"
      :key="componentRefresh">
    <a class="nav-link" :class="[classes]" :href="'#'+link" role="tab" data-toggle="tab"
       @click="$emit('onClick', link)">
      <slot/>
    </a>
  </li>
</template>

<script>
import checkPermissions from '../../../mixins/checkPermissions';

export default {
  name: "ks-tab-link",
  mixins: [checkPermissions],
  computed: {
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  },
  props: {
    classes: {
      type: String,
      default: null
    },
    link: {
      type: String,
      required: true
    }
  },
  methods: {
    active() {
      $('.nav-tabs a[href="#' + this.link + '"]').tab('show');
    }
  }
}
</script>
